export default class LoadingCell extends HTMLElement {
  constructor() {
    super();
    let estilo = document.createElement('style');
    estilo.innerHTML += `
      .loading-cell {
        position: relative;
        overflow: hidden;
        background-color: #e0e1e3;
        height: 20px;
        width: 100%;
        border-radius: 12px;
      }
      .loading-cell::after {
          content: '';
          animation: animacao-loading 1.2s infinite;
          height: 100%;
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
          transform: translateX(-100%);
          z-index: 1;
              background: linear-gradient(90deg, rgb(255,255,255, 0), rgb(255,255,255, 0.4), rgb(255,255,255, 0));
      }
      @keyframes animacao-loading {
          from {
              transform: translateX(-100%);
          }
          to {
              transform: translateX(100%);
          }
      }
    `;

    let cell = document.createElement('div');
    cell.classList.add('loading-cell');

    this.append(estilo);
    this.append(cell);
  }
}

customElements.define('loading-cell', LoadingCell);
